import React, { useEffect, useState } from "react";
import HeaderRoutes from "../../components/HeaderRoutes/HeaderRoutes";
import { Grid , Box , Paper, Typography , Button , Pagination , IconButton, Stack } from "@mui/material";
import { useTheme,styled } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import axios from 'axios';
import config from '../../config/config';
import Toast from '../../config/Toast';
import { DataGrid } from '@mui/x-data-grid';
import CircularProgress from '@mui/material/CircularProgress';
import PaginationComponent from "../../components/Pagination/Pagination";
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import moment from "moment";
import Modal from 'react-bootstrap/Modal';
import { useNavigate } from "react-router-dom";

const Version = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [loading , setLoading] = useState(true);
    const [versionList , setVersionList] = useState([])
    const [page, setPage] = useState(1); 
    const [rowsPerPage] = useState(5);
    const [totalPages, setTotalPages] = useState(0);
    const [rowCount, setRowCount] = useState(0);
    const [showView , setShowView] = useState(false);
    const [showData , setShowData] = useState([])
    const [deleteModal , setDeleteModal] = useState(false)
    const [message, setMessage] = useState('');
    const [selectedId , setSelectedId] = useState('')
    const [type, setType] = useState('');
    const navigate = useNavigate();

    const columns = [
        { field: 'id', headerName: 'ID', width: 90 },
        { field: 'android_version', headerName: 'Android Version', flex: 1 },
        { field: 'ios_version', headerName: 'iOS Version', flex: 1 },
        {
            field: 'created_at',
            headerName: 'Create Time',
            flex: 1,
            renderCell: (params) =>
            moment(params.value).format('MM/DD/YYYY ,  HH:mm:ss'), 
        },
        {
            field: 'updated_at',
            headerName: 'Update Time',
            flex: 1,
            renderCell: (params) =>
            moment(params.value).format('MM/DD/YYYY ,  HH:mm:ss'),
        },
        {
            field: 'Actions',
            headerName: 'Actions',
            flex: 1,
            sortable: false,
            filterable: false,
            renderCell: (params) => (
            <Stack direction="row" spacing={1}>
                <IconButton color="secondary">
                    <VisibilityIcon fontSize="small" 
                        onClick = {(e) => {
                            e.stopPropagation();
                            setShowView(true) 
                            fetchDataShow(params?.row?.id)
                        }}
                    />
                </IconButton>
                <IconButton color="secondary">
                    <EditIcon fontSize="small" 
                        onClick = {() => {
                            navigate(`/firehouse/versions-edit/${params?.row?.id}`)
                        }}
                    />
                </IconButton>
                <IconButton color="secondary">
                    <DeleteIcon fontSize="small" 
                         onClick = {(e) => {
                            e.stopPropagation();
                            setDeleteModal(true) 
                            setSelectedId(params?.row?.id)
                        }}
                    />
                </IconButton>
            </Stack>
            ),
        },
    ];
    
    const fetchData = async (pageNumber) => {
        const token = localStorage.getItem("tokenId");
        const path = `${config.authServiceUrl}versionsList?page=${pageNumber}`;

        setLoading(true);
        try {
            const response = await axios.get(path, {
                headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
                },
            });

            const res = response.data.data;
            setVersionList(res.data); 
            setRowCount(res.total); 
            setTotalPages(res.last_page); 
        } catch (error) {
            console.error(error.response?.data);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData(page);
    }, [page]);

    const fetchDataShow = async (id) => {
        const token = localStorage.getItem("tokenId");
        const path = `${config.authServiceUrl}showVersion/${id}`;
        try {
            const response = await axios.get(path, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });
            setShowData(response?.data?.data)
        } catch (error) {
            console.error(error.response?.data);
        } finally {
            setLoading(false);
        }
    };

    const handleCloseSnackbar = () => {
      setSnackbarOpen(false);
    };

    const handleClose = () => {
        setShowView(false)
        setShowData([])
    }

    const handleDelete = async () => {
        const path = `${config.authServiceUrl}deleteVersion/${selectedId}`;
        const token = localStorage.getItem("tokenId");
    
        try {
        const response = await axios.get(path, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        }); 
            setSnackbarOpen(true);
            setMessage(response?.data?.message);
            setType('success');
            fetchData(page);
            setDeleteModal(false)
        } catch (error) {
            const apiError = error.response?.data?.message || "An error occurred.";
            setMessage(apiError);
            setType('error');
            setSnackbarOpen(true);
        }
    };

     
  return (
    <>
      <HeaderRoutes />
      {loading && (
        <Box sx={{display:'flex', justifyContent:'center', marginTop:'20%'}}>
           <CircularProgress />
        </Box>
      )}
      {!loading && (
        <div>
          <Paper sx={{ margin: isMobile ? '16px' : '16px', padding: '20px 20px'}}>
            <Box>
                <div style={{display:'flex', alignItems:'center' , justifyContent:'space-between'}}>
                    <Typography
                        style={{
                        fontFamily: 'Karla',
                        fontStyle: 'normal',
                        fontSize: '20px',
                        lineHeight: '150%',
                        color: '#000000',
                        fontWeight: 500,
                        }}
                    >
                        Version List
                    </Typography>
                    <Button
                        variant="contained"
                        color="primary"
                        sx={{backgroundColor: '#BF1D2D', fontSize: '16px', fontWeight: '500', padding:'20px' ,  height: '38px' , boxShadow:'none' }}
                        onClick={ () => navigate('/firehouse/versions-add')}
                    >
                        Create New
                    </Button>
                </div>

              <Box sx={{ mt: 2}}>
                {versionList.length === 0 ? (
                  <Typography>No databases found.</Typography>
                ) : (
                    <DataGrid
                        rows={versionList}
                        columns={columns}
                        hideFooter={true}
                        loading={loading} 
                        getRowId={(row) => row.id}
                        disableRowSelectionOnClick = {true}
                    />
                )}
              </Box>
            </Box>

            <div style={{ display: "flex", justifyContent: "end", marginTop: 20 }}>
                <PaginationComponent
                    count={totalPages}
                    page={page}
                    onChange={(e, value) => setPage(value)}
                />
            </div>
        </Paper>
          
        </div>
      )}

      <Toast
            snackbarOpen={snackbarOpen}
            handleCloseSnackbar={handleCloseSnackbar}
            message={message}
            type={type}
        />

      <Modal show={showView} onHide={() => handleClose()}>
        <Modal.Header closeButton>
          <Modal.Title>View Version</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <p style={{ lineHeight: '1.2' }}>Id : {showData?.id}</p>
            <p style={{ lineHeight: '1.2' }}>Android Version: {showData?.android_version}</p>
            <p style={{ lineHeight: '1.2' }}>IOS Version: {showData?.ios_version}</p>
            <p style={{ lineHeight: '1.2' }}>
                Create Time: {moment(showData?.created_at).format('MM/DD/YYYY ,  HH:mm:ss')}
            </p>
            <p style={{ lineHeight: '1.2' }}>
                Update Time: {moment(showData?.updated_at).format('MM/DD/YYYY ,  HH:mm:ss')}
            </p>
        </Modal.Body>
      </Modal>

      <Modal show={deleteModal} onHide={() => setDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Delete Version</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            Are you sure to delete this version ?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" sx={{backgroundColor:'#cccccc' , marginRight:'10px'}} onClick={() => setDeleteModal(false)}>
            Cancel
          </Button>
          <Button variant="contained" sx={{backgroundColor:'#E62719' , color:'#ffffff'}} onClick={handleDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
      </>
  );
};

export default Version;



